import clsx from 'clsx';
import { ReactComponent as TrustedShopLogo } from '../assets/trusted-shop-logo.svg';
import { TRUSTED_SHOPS_FEEDBACK_URL } from '../config';
import { TrustedShopsStarRating } from '../TrustedShopsStarRating/TrustedShopsStarRating';
import { getTextGrade } from '../utils';
import styles from './TrustedShopsWidget.module.scss';

type TrustedShopsGradeTileProps = {
  rating: number;
  className?: string;
};

export const TrustedShopsGradeTile = ({
  rating,
  className,
}: TrustedShopsGradeTileProps) => {
  const textGrade = getTextGrade(rating) ?? rating.toFixed(1);

  return (
    <a
      href={TRUSTED_SHOPS_FEEDBACK_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={clsx(styles.gradeTile, className)}
      title="Zur Bewertungsseite von Trusted Shops"
    >
      <TrustedShopsStarRating rating={rating} aria-hidden />

      <span className="visually-hidden">Trusted Shops Bewertung:</span>
      <div className={styles.gradeScore}>
        {rating.toString().replace('.', ',')}
      </div>
      <span className="visually-hidden">von 5 Sternen (</span>
      <div className={styles.gradeText}>{textGrade}</div>
      <span className="visually-hidden">)</span>

      <TrustedShopLogo className={styles.logo} aria-hidden />
    </a>
  );
};
